import { InferSubmit, object, text } from '@if/core/yup'
import { ControlledTextField, useFormDialog } from '@if/mui'
import { MessageSquarePlus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import ReturnToCalendarAction, { RETURN_TO_CALENDAR, ToolResult } from './EditPayments-tool'

const noteSchema = object({ note: text() })

export type NoteSchemaType = InferSubmit<typeof noteSchema>

/**
 * Stamps one note onto every payment in scope. There is nothing to validate — an empty note
 * clears the ones already there — so Confirm is open from the moment it opens.
 */
export const useNoteDialog = () => {
  const { t } = useTranslation()

  return useFormDialog<NoteSchemaType, void, ToolResult<NoteSchemaType>>({
    icon: MessageSquarePlus,
    title: t('loan.payment.options.addNote'),
    confirmLabel: t('common.confirm'),
    maxWidth: 'sm',
    fullWidth: true,
    schema: noteSchema,
    successMessage: false,
    additionalActions: (ctx) => <ReturnToCalendarAction onReturn={() => ctx.close(RETURN_TO_CALENDAR)} />,
    onSubmit: (data) => data,
    content: ({ form }) => (
      <ControlledTextField
        control={form.control}
        name="note"
        label={t('loan.payment.description')}
        placeholder={t('loan.payment.options.addNote')}
        autoFocus
      />
    ),
  })
}
